module.exports = __webpack_public_path__ + "50be212ae4f1775ceff2e97fbdb0204b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-10.png
// module id = 2172
// module chunks = 0